// extracted by mini-css-extract-plugin
export default {"countdown":"xpa8jcvE","countdownSmall":"U1M7AqIw","countdownItem":"zRdL_bx6"};